module.exports = __webpack_public_path__ + "static/media/email_active.cf798786.png";